import { useContext } from 'react';

import { OptimizelyContext } from './OptimizelyWrapper';

export const useOptimizely = () => useContext(OptimizelyContext);
